import React, { Component } from "react";
import { Redirect } from 'react-router-dom'

import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";

export default class NewBlog extends Component {

  constructor(props){
    super(props);
    this.file = null;

    this.state = {
      errorMsg: "",
      successMsg: "",
      isLoading: null,
      content: "",
      title: "",
      isVideo: "false",
      isVideoUI: false,

    }
    if(this.props.location.state && this.props.location.state.blog){
      this.state.title= this.props.location.state.blog.title;
      this.state.content = this.props.location.state.blog.content;
      if(this.props.location.state.blog.isVideo === "true"){
        this.state.isVideo = "true";
        this.state.isVideoUI = true;
      }
    }
  }

  validateForm(){
    return this.state.content.length > 0 && this.state.title.length > 0;
  }

  handleIsVideoChange = event => {

    this.setState({
      [event.target.id]: !this.state[event.target.id+"UI"]+"",
      [event.target.id+"UI"]: !this.state[event.target.id+"UI"]

    });

  }

  handleChange = event => {
    event.preventDefault();
    this.setState({
      [event.target.id]: event.target.value,
      errorMsg: ""
    });
  }

  handleFileChange = event => {
    this.file = event.target.files[0];
    this.files = event.target.files;
  }

  handleSubmit = async event => {
    event.preventDefault();

    if(this.state.title.length === 0){
        this.setState({errorMsg: "Blog Title cannot be empty"});
        return;
    }

    if(this.state.content.length === 0){
        this.setState({errorMsg: "Blog Content cannot be empty"});
        return;
    }



    if(this.state.isVideo === "true" && this.files && this.files.length > 1){
      this.setState({errorMsg: "If it's a video you can only select one video file."});
      return;
    }

    if(this.state.isVideo === "true" && this.files && !this.files[0].name.endsWith(".mp4")){
      this.setState({errorMsg: "Please upload a MP4 format videos. Covert to MP4 here -> https://www.zamzar.com/"});
      return;
    }


    try{
      const attachments = [];
      if(this.files){
        for(var i = 0; i < this.files.length; i++){
            if(this.files[i].size > config.MAX_ATTACHMENT_SIZE){
              this.setState({errorMsg: "Please pick a file smaller than 20MB"});
              return;
            }
        }

       this.setState({ isLoading: true });

        //as all the files are in within our size limit upload them
        for(var i = 0; i < this.files.length; i++){
            // if(this.files[i].size < config.MAX_ATTACHMENT_SIZE){
               attachments[i] = this.files[i] ? await s3Upload(this.files[i]) : null;
            // }
        }
      }
      if(this.props.location.state){
        await this.editBlog({
           attachment: attachments.length > 0 ? attachments.join() : "",
           content: this.state.content,
           title: this.state.title,
           isVideo: this.state.isVideo
        })
      }else{
        await this.createBlog({
             attachment: attachments.length > 0 ? attachments.join() : "",
             content: this.state.content,
             title: this.state.title,
             isVideo: this.state.isVideo
        });

      }

      // this.setState({isLoading: false, successMsg: "Successfully added your blog"})
      this.props.history.push("/blogs");

    }catch(e){

      console.log(JSON.stringify(e));
      this.setState({isLoading: false, errorMsg: e.message});
    }
  }

  editBlog(blog){
    return API.put("retnetindia", "/blogs/"+this.props.location.state.blog.blogId, {
      body: blog
    })
  }

  createBlog(blog){

    return API.post("retnetindia", "/blogs", {
      body: blog
    })
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div class="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

  getSuccessNotification(successMsg){
    return this.state.successMsg && this.state.successMsg.length > 0
                            ? <div className="alert alert-success" role="alert">
                                {this.state.successMsg}
                              </div>
                            : "";
  }

  render(){

     if(!this.props.isAuthenticated){
       return(
         <Redirect to='/login' />
       );
     }

    return(
      <div className="container">
            <br />
            <div className="row cols-xs-space cols-sm-space cols-md-space">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-lg-2"></div>
                      <div className="col-lg-8 profile-udpate-widget">
                          <div className="card">
                              <div className="card-title b-xs-bottom">
                              {
                                this.props.location.state
                                       ? <h3 className="heading heading-sm text-uppercase">Edit Your Blog</h3>
                                       : <h3 className="heading heading-sm text-uppercase">Share your experiences with other doctors</h3>
                              }


                              </div>

                              <div className="card-body">

                              <form className="form-default" onSubmit={this.handleSubmit}>
                                    <div className="form-group">
                                        <label>Blog Title</label>
                                        <input type="text" id="title" onChange={this.handleChange}
                                            value={this.state.title}
                                            className="form-control form-control-lg input-mask"
                                            placeholder="" />
                                    </div>
                                    <div className="form-group">
                                        <label>Blog Content</label>
                                        <textarea id="content" onChange={this.handleChange}
                                              value={this.state.content}
                                              className="form-control form-control-lg textarea-autogrow"
                                              placeholder="Please start typing your blog content." rows="5">
                                        </textarea>
                                    </div>
                                    <div className="checkbox">
                                     <input type="checkbox"
                                            name="isVideo"
                                            onChange={this.handleIsVideoChange}
                                            checked={this.state.isVideoUI}
                                            id="isVideo" />
                                       <label for="isVideo">
                                           Video Attachment
                                      </label>
                                    </div>


                                     <div className="form-group">
                                         <label htmlFor="file-1">Upload Your Video / Images: &nbsp; &nbsp; </label>
                                         <input type="file" name="file-1[]"
                                                 id="file-1"
                                                 accept="image/*,audio/*,video/*"
                                                 onChange={this.handleFileChange} multiple/>
                                     </div>
                                     <br />
                                     <div className="form-group align-center">
                                       {
                                         this.props.location.state
                                                ? <LoaderButton block bsStyle="primary" bsSize="large"
                                                      disable={!this.validateForm()} type="submit"
                                                      isLoading={this.state.isLoading} text="Edit Blog"
                                                      loadingText="Editing Blog..."
                                                      className="btn btn-primary"/>
                                                : <LoaderButton block bsStyle="primary" bsSize="large"
                                                      disable={!this.validateForm()} type="submit"
                                                      isLoading={this.state.isLoading} text="Create Blog"
                                                      loadingText="Creating Blog..."
                                                      className="btn btn-primary"/>
                                       }


                                     </div>
                                     <span className="text-primary"><u>Note:</u></span><br />
                                     <span className="text-primary">Each attachment cannot be more than 20 MB</span> <br/>
                                     <span className="text-primary">Attach only mp4 format videos</span> <br/>
                                     <span className="text-primary">Only one video attachment is allowed. Images can be one or more</span>


                              </form>
                                {this.getErrorElement()}
                                {this.getSuccessNotification()}

                              </div>
                          </div>
                      </div>
                      <div className="col-lg-2"></div>
                    </div>

                  </div>
            </div>
            <br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NewBlog.js